// faq.js
export function toggleFaq(id) {
  const answer = document.querySelector(`[data-answer-id="${id}"]`);
  const icon = document.querySelector(`[data-icon-id="${id}"]`);

  // Toggle answer visibility
  answer.classList.toggle("hidden");

  // Toggle icon rotation
  if (icon.classList.contains("fa-chevron-down")) {
    icon.classList.replace("fa-chevron-down", "fa-chevron-up");
  } else {
    icon.classList.replace("fa-chevron-up", "fa-chevron-down");
  }
}
